import Format from 'app/src/data/Format';
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import { TERMINAL_TYPE } from 'shared_modules/Terminals';

export default class CCTerminal extends RetailModel {
  /**
   * Exports the GatewayType
   */
  static get TerminalType() {
    return TERMINAL_TYPE;
  }

  // Server uses the ccTerminalID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'ccTerminalID';
  }

  get defaults() {
    return {
      name: '',
      createTime: '',
      timeStamp: '',
      type: '',
      shopID: 0,
      gatewayConfigID: 0,
    };
  }

  get retailResponseName() {
    return 'CCTerminal';
  }

  /**
   * Getter for the terminal configuration.
   *
   * @returns {{}}
   */
  get configuration() {
    let configuration = {};
    if (this.has('configuration')) {
      configuration = this.get('configuration');
    }

    return configuration;
  }

  /**
   * Return the url for the CCTerminal endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/CCTerminal');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let ccTerminal = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    if (
      ccTerminal.ccTerminalID &&
      ccTerminal.ccTerminalID.match &&
      !ccTerminal.ccTerminalID.match(/-/)
    ) {
      // the ID may be a UUID for certain types of terminals (e.g. Blackline)
      ccTerminal.ccTerminalID = Format.parseInt(ccTerminal.ccTerminalID);
    }
    ccTerminal.shopID = Format.parseInt(ccTerminal.shopID);

    if (
      ccTerminal.gatewayConfigID &&
      ccTerminal.gatewayConfigID.match &&
      !ccTerminal.gatewayConfigID.match(/-/)
    ) {
      // We need to support retail configurations (interger ID) and payment service configuration (UUID)
      ccTerminal.gatewayConfigID = Format.parseInt(ccTerminal.gatewayConfigID);
    }

    return ccTerminal;
  }
}
